export default {
  inject: ['load'],
  data() {
    return {
      allSkinTurgorsForOther: [],
      skinTurgor: null,
    };
  },
  methods: {
    getListOfSkinTurgorsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllSkinTurgors').then(() => {
        if (this.$store.state.skinTurgorModule.successFlag) {
          this.allSkinTurgorsForOther = this.$store.state.skinTurgorModule.allSkinTurgors;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.skinTurgorModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfSkinTurgorsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getSkinTurgorFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getSkinTurgor', id).then(() => {
        if (this.$store.state.skinTurgorModule.successFlag) {
          this.skinTurgor = this.$store.state.skinTurgorModule.skinTurgor;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.skinTurgorModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getSkinTurgorFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.skinTurgorModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
